module.exports = __webpack_public_path__ + "img/inner-members-profile-bm.42f8e4b6.png";